import { render } from "./MailPermissionConfirm.vue?vue&type=template&id=958e41bc&ts=true"
import script from "./MailPermissionConfirm.vue?vue&type=script&lang=ts"
export * from "./MailPermissionConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1253990065/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__